__webpack_require__.p = "/dtxviewertool/";